import { render, staticRenderFns } from "./HubbleLawViz.vue?vue&type=template&id=4afeee40&scoped=true"
import script from "./HubbleLawViz.vue?vue&type=script&lang=js"
export * from "./HubbleLawViz.vue?vue&type=script&lang=js"
import style0 from "./HubbleLawViz.vue?vue&type=style&index=0&id=4afeee40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afeee40",
  null
  
)

export default component.exports